<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>

        <v-card class="shadow-none" v-if="!needInit">     
            <v-card-text v-if="myContent">
                <div v-html="myContent.content"></div>                    
                <v-layout row wrap align-center v-for="(item, index) in myContent.answer_list" :key="index">                            
                    <v-flex xs1>
                        <v-layout justify-center v-if="myAnswers.indexOf(index) > -1 && showFeedback">
                            <v-icon large color="green" v-if="item.rating>0">check_circle</v-icon>
                            <v-icon large color="red" v-if="item.rating<=0">error</v-icon>
                        </v-layout>
                    </v-flex>
                    <v-flex xs11>
                        <v-checkbox v-model="myAnswers" :label="item.answer" @click.native="reset()" :value="index"></v-checkbox>                        
                        <p v-if="myAnswers.indexOf(index) > -1 && showFeedback" :style="getStyle(item.rating)">{{item.feedback}}</p>
                    </v-flex>
                </v-layout>
                                                   
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth.js'
import * as logs from '../../assets/log_process.js'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myAnswers : [],
                feedback: null,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                showFeedback: false,
                startTime : null
        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    ])
    ,    
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    methods: {
        initData() {
            this.needInit = false         
            this.showFeedback = false
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)

            // shuffle
            var rand = 0
            const _times = 2+Math.floor(Math.random()*3)
            for (let j=0; j<_times; j++) {
                for(let i=0; i < this.myContent.answer_list.length; i++) {
                    rand = Math.floor(Math.random() * this.myContent.answer_list.length);
                    [this.myContent.answer_list[i], this.myContent.answer_list[rand]] = [this.myContent.answer_list[rand], this.myContent.answer_list[i]];
                }                             
            }
        },
        reset() {
            this.showFeedback = false
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent',false) 

            var answList = []
            for(let i = 0; i < this.myAnswers.length; i++) {
                answList.push(this.myContent.answer_list[this.myAnswers[i]].answer)
            }

            // send info to server
            const data = {
                task_id : this.dcontent.task_id,
                task_type_id: this.dcontent.task_type_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                answer_list : JSON.stringify(answList), 
                activity_type: this.activity_type
            }
            /* eslint-disable no-console */
            axios.post('/task-evaluate2', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useEvaluation(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        useEvaluation(myData) {          
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)

            for(let i=0; i<this.myAnswers.length; i++) {
                this.myContent.answer_list[this.myAnswers[i]] = {
                    answer: myData.result.answers[i].answer,
                    feedback: myData.result.answers[i].feedback,
                    rating: myData.result.answers[i].rating
                }
            }

            this.showFeedback = true
        },  
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        },        
        useAnswer(myData) {
            this.myAnswers = []
            for(let i = 0; i < myData.answers.length; i++) {
                for(let j = 0; j < this.myContent.answer_list.length; j++) {
                    if (myData.answers[i].answer == this.myContent.answer_list[j].answer) {
                        this.myContent.answer_list[j] = {
                            answer: myData.answers[i].answer,
                            feedback: myData.answers[i].feedback,
                            rating: 1
                        }
                        this.myAnswers.push(j)                      
                        break
                    }
                }
            }

            this.showFeedback = true
            this.$store.commit('setUserPerformance',myData.user)
        },          
        getStyle(value) {
            return { color: this.getColor(value)}
        },
        getColor(value) {
            if (!this.showFeedback) return "black"
            return value > 0 ? "green" : "red"
        },       
    },
    mounted() {
        this.needInit = true
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>

<style>
</style>